module.exports = __webpack_public_path__ + "static/media/KioskOrderTypeSelection.83de777a.png";